<app-base-modal
  size="standard"
  [title]="bankDetailsResourceType.name"
  [showStateToggle]="bankDetailsValid()"
  [modalMaxHeight]="'85vh'"
>
  @if (isLoading) {
    <app-loader/>
  }

  @if (bankDetailsValid()) {
    <app-current-bank-details
      [bankDetailsDialogData]="bankDetailsDialogData"
      [legalEntityTypes]="legalEntityTypes()"
      [isEditModeActive]="isEditModeActive"
      (unbindBankDetails)="handleButtonClick(null)"
      (closeDialog)="closeDialog($event)"
    />
  } @else {
    <app-new-bank-details
      [bankDetailsDialogData]="bankDetailsDialogData"
      [legalEntityTypes]="legalEntityTypes()"
      (handleSaveButtonClick)="handleButtonClick($event)"
      (closeDialog)="closeDialog($event)"
    />
  }
</app-base-modal>
